module.exports = "/static/media/lineto-circular-bookitalic.102d011e.woff2";